module.exports = __webpack_public_path__ + "img/Amex.f5062c05.svg";